const TopicsCoveredCard = ({topicscover}) => {
  return (
    <>
      <div className="card mb-4 bg-gradient-glass backdrop-filter-20px border-common">
        <div className="card-body p-4">
          <h5 className="text-white fw-bold mb-3">📚 Topics Covered</h5>
          <div className="d-flex flex-wrap gap-2">
            {topicscover && topicscover.length > 0 ? (
            topicscover.map((topic, index) => (
              <span
                key={index}
                className="badge rounded-pill px-3 py-2 text-white fs-6 bg-gradient-primary"
              >
                {topic}
              </span>
            ))
          ) : (
            <p className="text-white-50">No topics available</p>
          )}
          </div>
        </div>
      </div>
    </>
  )
}

export default TopicsCoveredCard;